// extracted by mini-css-extract-plugin
export default {"Box":"SubIssueRemovedEvent-module__Box--bvq7v","Box_1":"SubIssueRemovedEvent-module__Box_1--gW0DM"};